
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91participant_937Nc9ZVEC71gRSYzLeBheYw72Yxk0olXty0qDz1lKD8YMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/form/[event]/participant/[participant].vue?macro=true";
import { default as _91event_93EUh2oyfxcwuTxSQU_Dwta_45Sr5_459A0TNljaoc4ceKD_45UMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/form/[event].vue?macro=true";
import { default as _91signature_93QZqU2cqW2qxsuFFEEmP8KyhiLPbXPsS0bS8cDsOtU8kMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/form/signatures/[signature].vue?macro=true";
import { default as form3k03fPZLg3mst_45aoQrGwGwnNAHkO6MK9tRog7FGGpFwMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/form.vue?macro=true";
import { default as indexYcEGHDXRzim_2dVf901XSmxOXLFpO_xduf_t1_vVRC8Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/index.vue?macro=true";
import { default as mailBaseData7HYKaVYaip83cN0rZSCnlJ49JcZJHERJxnAKYDrvtcMMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/mails/[id]/mailBaseData.vue?macro=true";
import { default as mailActivitiestF0_tyAho8W5XPSqJ98T3aR9wqR8R3iNiSQZxTE9E5cMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/mails/[id]/mailActivities.vue?macro=true";
import { default as _91id_93mW7jG33hfLrviZnfNWG9MIGWJmtqKalefobaikjkOfoMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/mails/[id].vue?macro=true";
import { default as indexb3hY_AydIMrAFC_F8bkOT6ZCABZqp5NN7by_45f_45JDsX4Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/mails/index.vue?macro=true";
import { default as mailsSURVMb4xQtp_45KeDLZdhtE6kR8bfxhoCV_45JBte_oYlMgMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/mails.vue?macro=true";
import { default as eventMailsBq4ZFmJhvjrzjhDztIfONLMMrXHRavxE77wl7A6hOO4Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventMails.vue?macro=true";
import { default as eventLeadersydo8ltzMhdOUSYOaThwx4QDH_4562SlpaQJI196IBFQssMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventLeaders.vue?macro=true";
import { default as eventBaseDataBN_45_YV2t_45UY6IEM6xG6W1lZdOlwdAx5YGCDwdOFq4_AMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventBaseData.vue?macro=true";
import { default as eventQuestionsJkXxZx4TKuDycV0KpQJHu9bVziYQDV9uSo1UzO3ZTyMMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventQuestions.vue?macro=true";
import { default as eventActivities2u4_Ma9u0IAt1V84bIktZidv81vlwjpXVBdgz9hQGr0Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventActivities.vue?macro=true";
import { default as eventParticipantsshLwxBqeZmHLid1Qk_Td1WQwF3vJ5UC18lKQSz1rKh4Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventParticipants.vue?macro=true";
import { default as eventCrisisManagersiEkg0Y7V_452YR3_YhKe8bWoEUYglIVqR_Ih7Mn4cKCxoMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventCrisisManagers.vue?macro=true";
import { default as eventParticipantGroupsSoR8CAX_45pi9B8zB04ECKH6Xp044TxFAqCnEuKkss3AsMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventParticipantGroups.vue?macro=true";
import { default as eventTemporaryAccessesKn7qyy2irlsW6ocC_45jIE4opeGpcw1iPwAc6kqDzfjfYMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventTemporaryAccesses.vue?macro=true";
import { default as _91id_930ZBTV78m4C_45TtoMffFlAHmxGlCYCVYRmAG7oKulB2MEMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id].vue?macro=true";
import { default as indexEIFkHK4xga2CmMjK1QdQxf_45XR5IBVwW2S4jLCO4I6kUMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/index.vue?macro=true";
import { default as participantMailsaRbU3019tIY0d1XGBclNPdl9DQTidjUZZig6EYTgMeoMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id]/participantMails.vue?macro=true";
import { default as participantAnswers6fnyP_45MSOF4MWY06ONvYn8_45qikwUA1KqKC1_45zmF13YUMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id]/participantAnswers.vue?macro=true";
import { default as participantBaseDatade0ZVylK0dpyiCwfB6mfboWYc5T57CF8qMxO6M4Lmj8Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id]/participantBaseData.vue?macro=true";
import { default as participantGuardiansJ12Lgs_6ftHo3Ic3gxvrG5RO1c00e93TmSI8cUENyqUMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id]/participantGuardians.vue?macro=true";
import { default as participantActivitiesEDf6kiGP8uDWN17pdEqBzhaca1QXn7ZVnG2UcdDaBQAMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id]/participantActivities.vue?macro=true";
import { default as participantSubmissionsR6pwucFuoENLnDKK5nXD3Wz8l7_P3CYloZIGSZLNKLgMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id]/participantSubmissions.vue?macro=true";
import { default as participantEmergencyContactsVclCTYyfPR6uLDn_45N2O2RzCHfDPvlZ5yVjWgtvKOhl0Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id]/participantEmergencyContacts.vue?macro=true";
import { default as participantTemporaryAccessesFfLLuDQWaTXjAVU_45yeJgm29fA8JieBY_J0h6eM9u_cgMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id]/participantTemporaryAccesses.vue?macro=true";
import { default as _91id_93bhtP8oL80FdZlM37Ydcyf0pDces9Ph3_D_45jJcy3usVsMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id].vue?macro=true";
import { default as groupBaseDatafLKTOVSWCDax56Ev3FhAH5l3bU_howRhYvMo2CAqKlsMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participantGroups/[id]/groupBaseData.vue?macro=true";
import { default as groupActivitiesemGlbS4jG_45tkXYlgwKHmax8uzkWe9UYJcnmyMXsY3H4Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participantGroups/[id]/groupActivities.vue?macro=true";
import { default as groupParticipantscGvVhpgHk0Veap_45ad5IwKr9lp9qA_45nzd4xtfQOhrP0sMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participantGroups/[id]/groupParticipants.vue?macro=true";
import { default as groupTemporaryAccessesM9zVLjY3r4wKxVtRSUPv9fgtIkhCtkeFYhFUtEFTEk8Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participantGroups/[id]/groupTemporaryAccesses.vue?macro=true";
import { default as _91id_936gBIWpZxJiK0_W7XTtlARhWHVdYG4RL0ZDrGv1eQAXcMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participantGroups/[id].vue?macro=true";
import { default as eventsv_45po5XoSKLx5GsP4WwqxjIHCqo0_45jfwBYYxTQaaeq3EMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events.vue?macro=true";
import { default as roles3_YcOFxskWgY_m3SdjzaV_45SharhthIxUKFxTwiJXioQMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/roles.vue?macro=true";
import { default as userBaseDataVq3O7bTSHxPi_dzeOVeCPcCoCRJHh6Iql4_45BhYqJAJAMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/users/[id]/userBaseData.vue?macro=true";
import { default as userActivitiesfzO_Gh49pWOhLIyKynLQ_45vCaXsmzVoarb4bPEoNdZJsMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/users/[id]/userActivities.vue?macro=true";
import { default as _91id_93WTqkLb_45V6mgOVWpVDNCn2yD0qCVFo1DuOC4s_Na4NocMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/users/[id].vue?macro=true";
import { default as indexWT685CXPoVx9KSaX1KUoHjEhsRxOIVJRkzKeW2kJmVoMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/users/index.vue?macro=true";
import { default as users_45gM0mqBjg_gWJkVI7y69CABP1Qq74VUj9ELEMqJNqPEMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/users.vue?macro=true";
import { default as baseData4ifNw5poklzHWqA_kizREASSBwYrkLbeaUaft35qsHYMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/baseData.vue?macro=true";
import { default as billingsdMonJpoo2YiC2YDvBGm11eF2BMSHzBVzKMAOz4U2kMoMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/billings.vue?macro=true";
import { default as billingRunsLOhkn_45sedolj0C3gd_uVTsCokdQYL5vE1dtgZlAjHYoMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/billingRuns.vue?macro=true";
import { default as organisationUsersfj5O0VB9f5wthqqIn6EKPP0LVtK_45EwseFcdQgtOrt00Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations/[id]/organisationUsers.vue?macro=true";
import { default as organisationPackage6mGQKoyzvKOU6imuIaFtXZ7NlEQ86VvZJvmhQGRp__45gMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations/[id]/organisationPackage.vue?macro=true";
import { default as organisationBaseDataCoo82o3_7_uC6wtWjNMIitTV6inibtBCZBTmmcfhI0AMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationActivities2svEjMql5o4zxNV_tp4us82382tYT0pW1zJN1BuSt9oMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationSystemDataN8LuokDLlTd8WObF6Ut0B_f_45BAB_qkdUHkQEiahjlEEMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations/[id]/organisationSystemData.vue?macro=true";
import { default as organisationMailSettingsigOS_45kCKQe1BWa7YKekPLQ7YYc5rJig_JWdrQUYLaTsMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations/[id]/organisationMailSettings.vue?macro=true";
import { default as _91id_93Wl89T2mSOXy_fTQw_45tW7dvWT2NzgXOXYZmJj0LsqKvoMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations/[id].vue?macro=true";
import { default as indexJNQ9JLvF8Foalw3jMBBtQUBe9qVuarwHzm9Swpu7fCwMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations/index.vue?macro=true";
import { default as organisations8sCkDxrAp0ZAcDmMLpp3dN3cTF8xBNWqqVAS5vjmB3IMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations.vue?macro=true";
import { default as poolQuestionsxYYVvqfRD5iv0xUqKzWCrFLmp8JAD3KH7KeunGqcufUMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/poolQuestions.vue?macro=true";
import { default as indexthrQ8W_ml1lCIGg7vJz7uIITIrvDzCHUuCT5g_qHbFsMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/mailTemplates/index.vue?macro=true";
import { default as mailTemplateBaseDataKX08HvUbWIhYhudKw6EZKP0V9k2_FF0NuL41tv92vNAMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as systemUgZqDUd5xgMmCR0DvmqRDZh1fhM4qQ8YFnqJKw1KIwYMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system.vue?macro=true";
import { default as userBaseDataj4m3Qi634_45_o1ptpVycmKeSrJvoSalkzaVoclxbhd6cMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/users/[id]/userBaseData.vue?macro=true";
import { default as userActivitiesUw1vjjXtTfZH8wNBDbYB1dLZ1cdnAg_aCqUuq7TkT6gMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/users/[id]/userActivities.vue?macro=true";
import { default as _91id_93GKd2niNYibVyJHfejCW10MpUr9VlqATa6lJ8MQrO6n4Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/users/[id].vue?macro=true";
import { default as organisationUsers8adjZkYOSMW0d_4510JsADXJ7iuOc1k7ympowOLy9kHtMMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/organisation/organisationUsers.vue?macro=true";
import { default as organisationPackageUEdDNL6MkOeDE1ftvTFtDGOltxlxUZG8ZJIerLfKrtQMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/organisation/organisationPackage.vue?macro=true";
import { default as organisationBaseData5JTZ_45WXqZQkmF1oFK1muXr_LyRpr3kJ_45RMwVvyjavgEMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/organisation/organisationBaseData.vue?macro=true";
import { default as organisationMailSettingssdu_0tQASMTAaTVwNNAZ4p67y60P41MlYGZMgpGLsMIMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/organisation/organisationMailSettings.vue?macro=true";
import { default as organisation6PZybWQh1SQjMnVLOHZm_45XVGMqGE6SqpmEVmDVNKf_450Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/organisation.vue?macro=true";
import { default as mailTemplateBaseDataBfSE9csUvOQM5JWZopkaoboy71plt9vAG2m6f5r2RbEMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as internaltx5CLKRlnNWeNlx5cQg8hUfeYgsG3Fyb3Ck2HxBNlpYMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal.vue?macro=true";
import { default as _91id_93tPN9S68bEUk7hG1EMMiaM0tNoj6IToINweDmSD5TLEoMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/crisisManagers/[id].vue?macro=true";
import { default as _91id_93pak6G2SdrAKTx6YEPATG9U3P8BpdhI3ZJweZdi_45iHL8Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/loginProviders/[id].vue?macro=true";
import { default as index2ZRYSHl67T1BaNjLus3k_kVOKR6cjKvr3P8Fnz5yn_45EMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/crisisManagers/index.vue?macro=true";
import { default as indexS43JuOX9RdfBYpMhTo3PIEXTsibGIj2BSz4q3vqolXcMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/loginProviders/index.vue?macro=true";
import { default as settingsjHe0VBedB_45ur1Zoiw8_4514tl9vE2FX9OyscE_E_45l_450acMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings.vue?macro=true";
import { default as setBaseDatam6ljxrzBYRpUtxKXNnA9Mn8OUGsq61TvBaVj38zTiy8Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/questions/sets/[id]/setBaseData.vue?macro=true";
import { default as _91id_93f1BAhgMeD_exeysFd30uTxp12yOe_45NE_456Ya1tv8RNcIMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/questions/sets/[id].vue?macro=true";
import { default as index_a_45mlK6Wyc_45pfaigtfomnzU4aIKKcCxcsEnLf5fV9tEMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/questions/sets/index.vue?macro=true";
import { default as sets6rkDb08IG0Kw_s5998MIZ5MuSGVk253_45YYFq0gMCEmEMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/questions/sets.vue?macro=true";
import { default as questions4PIEdTxFwu8U5MjDG4ckHGyRlaXk8CEm44euSU_g1k4Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/questions.vue?macro=true";
import { default as indexKrBHzrNCXCYMTrEzgojm1R41Pab1qbQojF65JyPFhS4Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/auth/index.vue?macro=true";
import { default as inputsU_WfTmQPzGgedVhFRL4n6AXEy_G90AueuQ_45ZnDm2kFYMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/secret/index/inputs.vue?macro=true";
import { default as mosaicZHJwq91fVUrWneTHkwYmiq1z9xMaww4BcTGio4rm87wMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/secret/index/mosaic.vue?macro=true";
import { default as dungeonbiyaf_45Dt6XZ2LmOWVkHfqVJBhfjaMjssWAHYnfAEWBIMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/secret/index/dungeon.vue?macro=true";
import { default as componentsyRgjjOWV85oK2YqNb_WOG4UxS636O4v0WpfwSHyM8TIMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/secret/index/components.vue?macro=true";
import { default as index2c_454lEDyLfXpVpM6t_IsaA7_PYiilNoXS8Bio8NohHcMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/secret/index.vue?macro=true";
import { default as registersB0hIKnZriwrf2Vklgg_s9K28HPJzzlAVDf5jSyTrS8Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/auth/register.vue?macro=true";
import { default as _91leader_93yxtvR7GcGWMS140N79f7CWtikx4aR_45yBN83myEIOOhgMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/external/event/[event]/leader/[leader].vue?macro=true";
import { default as _91emergency_93HfObekiFJH0IdOJDakuA8cgZyS3pSdMehH4Xo6RaC4MMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/external/event/[event]/emergency/[emergency].vue?macro=true";
import { default as _91temporary_93Nyml1J9mMXjqlO84e7PVfbJ3n7zHk31VNvhqPzNvhFEMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/external/event/[event]/temporary/[temporary].vue?macro=true";
import { default as _91event_93pk2TjiBl1u_455xpqC4ZjybTC2mLLZArujjB9vslJqcq0Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/external/event/[event].vue?macro=true";
import { default as eventfB4fkgV6GkW8GZhm8RvTX5A64tY3dNa6vkQ_xxiplk0Meta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/external/event.vue?macro=true";
import { default as indexG_45fqNo3POh2E2KKW99IMvj1Hv_X2KFOugs2x7USYvmcMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/auth/amos/[organisation]/index.vue?macro=true";
import { default as indexBxQV4s1k_45tkAmOlSYmt0ayqEYXOprpXbMsAAJx5fURwMeta } from "/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/auth/social/[organisation]/index.vue?macro=true";
export default [
  {
    name: "form",
    path: "/form",
    meta: form3k03fPZLg3mst_45aoQrGwGwnNAHkO6MK9tRog7FGGpFwMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/form.vue"),
    children: [
  {
    name: "form-event",
    path: ":event()",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/form/[event].vue"),
    children: [
  {
    name: "form-event-participant-participant",
    path: "participant/:participant()",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/form/[event]/participant/[participant].vue")
  }
]
  },
  {
    name: "form-signatures-signature",
    path: "signatures/:signature()",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/form/signatures/[signature].vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/index.vue")
  },
  {
    name: mailsSURVMb4xQtp_45KeDLZdhtE6kR8bfxhoCV_45JBte_oYlMgMeta?.name,
    path: "/mails",
    meta: mailsSURVMb4xQtp_45KeDLZdhtE6kR8bfxhoCV_45JBte_oYlMgMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/mails.vue"),
    children: [
  {
    name: "mails-id",
    path: ":id()",
    meta: { ...(_91id_93mW7jG33hfLrviZnfNWG9MIGWJmtqKalefobaikjkOfoMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/mails/[id].vue"),
    children: [
  {
    name: "mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/mails/[id]/mailBaseData.vue")
  },
  {
    name: "mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/mails/[id]/mailActivities.vue")
  }
]
  },
  {
    name: "mails",
    path: "",
    meta: { ...(indexb3hY_AydIMrAFC_F8bkOT6ZCABZqp5NN7by_45f_45JDsX4Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/mails/index.vue")
  }
]
  },
  {
    name: eventsv_45po5XoSKLx5GsP4WwqxjIHCqo0_45jfwBYYxTQaaeq3EMeta?.name,
    path: "/events",
    meta: eventsv_45po5XoSKLx5GsP4WwqxjIHCqo0_45jfwBYYxTQaaeq3EMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events.vue"),
    children: [
  {
    name: "events-id",
    path: ":id()",
    meta: _91id_930ZBTV78m4C_45TtoMffFlAHmxGlCYCVYRmAG7oKulB2MEMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id].vue"),
    children: [
  {
    name: "events-id-eventMails",
    path: "eventMails",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventMails.vue")
  },
  {
    name: "events-id-eventLeaders",
    path: "eventLeaders",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventLeaders.vue")
  },
  {
    name: "events-id-eventBaseData",
    path: "eventBaseData",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventBaseData.vue")
  },
  {
    name: "events-id-eventQuestions",
    path: "eventQuestions",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventQuestions.vue")
  },
  {
    name: "events-id-eventActivities",
    path: "eventActivities",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventActivities.vue")
  },
  {
    name: "events-id-eventParticipants",
    path: "eventParticipants",
    meta: eventParticipantsshLwxBqeZmHLid1Qk_Td1WQwF3vJ5UC18lKQSz1rKh4Meta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventParticipants.vue")
  },
  {
    name: "events-id-eventCrisisManagers",
    path: "eventCrisisManagers",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventCrisisManagers.vue")
  },
  {
    name: "events-id-eventParticipantGroups",
    path: "eventParticipantGroups",
    meta: eventParticipantGroupsSoR8CAX_45pi9B8zB04ECKH6Xp044TxFAqCnEuKkss3AsMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventParticipantGroups.vue")
  },
  {
    name: "events-id-eventTemporaryAccesses",
    path: "eventTemporaryAccesses",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[id]/eventTemporaryAccesses.vue")
  }
]
  },
  {
    name: "events",
    path: "",
    meta: { ...(indexEIFkHK4xga2CmMjK1QdQxf_45XR5IBVwW2S4jLCO4I6kUMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/index.vue")
  },
  {
    name: "events-event-participants-id",
    path: ":event()/participants/:id()",
    meta: _91id_93bhtP8oL80FdZlM37Ydcyf0pDces9Ph3_D_45jJcy3usVsMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id].vue"),
    children: [
  {
    name: "events-event-participants-id-participantMails",
    path: "participantMails",
    meta: participantMailsaRbU3019tIY0d1XGBclNPdl9DQTidjUZZig6EYTgMeoMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id]/participantMails.vue")
  },
  {
    name: "events-event-participants-id-participantAnswers",
    path: "participantAnswers",
    meta: participantAnswers6fnyP_45MSOF4MWY06ONvYn8_45qikwUA1KqKC1_45zmF13YUMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id]/participantAnswers.vue")
  },
  {
    name: "events-event-participants-id-participantBaseData",
    path: "participantBaseData",
    meta: participantBaseDatade0ZVylK0dpyiCwfB6mfboWYc5T57CF8qMxO6M4Lmj8Meta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id]/participantBaseData.vue")
  },
  {
    name: "events-event-participants-id-participantGuardians",
    path: "participantGuardians",
    meta: participantGuardiansJ12Lgs_6ftHo3Ic3gxvrG5RO1c00e93TmSI8cUENyqUMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id]/participantGuardians.vue")
  },
  {
    name: "events-event-participants-id-participantActivities",
    path: "participantActivities",
    meta: participantActivitiesEDf6kiGP8uDWN17pdEqBzhaca1QXn7ZVnG2UcdDaBQAMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id]/participantActivities.vue")
  },
  {
    name: "events-event-participants-id-participantSubmissions",
    path: "participantSubmissions",
    meta: participantSubmissionsR6pwucFuoENLnDKK5nXD3Wz8l7_P3CYloZIGSZLNKLgMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id]/participantSubmissions.vue")
  },
  {
    name: "events-event-participants-id-participantEmergencyContacts",
    path: "participantEmergencyContacts",
    meta: participantEmergencyContactsVclCTYyfPR6uLDn_45N2O2RzCHfDPvlZ5yVjWgtvKOhl0Meta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id]/participantEmergencyContacts.vue")
  },
  {
    name: "events-event-participants-id-participantTemporaryAccesses",
    path: "participantTemporaryAccesses",
    meta: participantTemporaryAccessesFfLLuDQWaTXjAVU_45yeJgm29fA8JieBY_J0h6eM9u_cgMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participants/[id]/participantTemporaryAccesses.vue")
  }
]
  },
  {
    name: "events-event-participantGroups-id",
    path: ":event()/participantGroups/:id()",
    meta: _91id_936gBIWpZxJiK0_W7XTtlARhWHVdYG4RL0ZDrGv1eQAXcMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participantGroups/[id].vue"),
    children: [
  {
    name: "events-event-participantGroups-id-groupBaseData",
    path: "groupBaseData",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participantGroups/[id]/groupBaseData.vue")
  },
  {
    name: "events-event-participantGroups-id-groupActivities",
    path: "groupActivities",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participantGroups/[id]/groupActivities.vue")
  },
  {
    name: "events-event-participantGroups-id-groupParticipants",
    path: "groupParticipants",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participantGroups/[id]/groupParticipants.vue")
  },
  {
    name: "events-event-participantGroups-id-groupTemporaryAccesses",
    path: "groupTemporaryAccesses",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/events/[event]/participantGroups/[id]/groupTemporaryAccesses.vue")
  }
]
  }
]
  },
  {
    name: "system",
    path: "/system",
    meta: systemUgZqDUd5xgMmCR0DvmqRDZh1fhM4qQ8YFnqJKw1KIwYMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system.vue"),
    children: [
  {
    name: "system-roles",
    path: "roles",
    meta: roles3_YcOFxskWgY_m3SdjzaV_45SharhthIxUKFxTwiJXioQMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/roles.vue")
  },
  {
    name: users_45gM0mqBjg_gWJkVI7y69CABP1Qq74VUj9ELEMqJNqPEMeta?.name,
    path: "users",
    meta: users_45gM0mqBjg_gWJkVI7y69CABP1Qq74VUj9ELEMqJNqPEMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/users.vue"),
    children: [
  {
    name: "system-users-id",
    path: ":id()",
    meta: { ...(_91id_93WTqkLb_45V6mgOVWpVDNCn2yD0qCVFo1DuOC4s_Na4NocMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/users/[id].vue"),
    children: [
  {
    name: "system-users-id-userBaseData",
    path: "userBaseData",
    meta: userBaseDataVq3O7bTSHxPi_dzeOVeCPcCoCRJHh6Iql4_45BhYqJAJAMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/users/[id]/userBaseData.vue")
  },
  {
    name: "system-users-id-userActivities",
    path: "userActivities",
    meta: userActivitiesfzO_Gh49pWOhLIyKynLQ_45vCaXsmzVoarb4bPEoNdZJsMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/users/[id]/userActivities.vue")
  }
]
  },
  {
    name: "system-users",
    path: "",
    meta: { ...(indexWT685CXPoVx9KSaX1KUoHjEhsRxOIVJRkzKeW2kJmVoMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/users/index.vue")
  }
]
  },
  {
    name: "system-baseData",
    path: "baseData",
    meta: baseData4ifNw5poklzHWqA_kizREASSBwYrkLbeaUaft35qsHYMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/baseData.vue")
  },
  {
    name: "system-billings",
    path: "billings",
    meta: billingsdMonJpoo2YiC2YDvBGm11eF2BMSHzBVzKMAOz4U2kMoMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/billings.vue")
  },
  {
    name: "system-billingRuns",
    path: "billingRuns",
    meta: billingRunsLOhkn_45sedolj0C3gd_uVTsCokdQYL5vE1dtgZlAjHYoMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/billingRuns.vue")
  },
  {
    name: organisations8sCkDxrAp0ZAcDmMLpp3dN3cTF8xBNWqqVAS5vjmB3IMeta?.name,
    path: "organisations",
    meta: organisations8sCkDxrAp0ZAcDmMLpp3dN3cTF8xBNWqqVAS5vjmB3IMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations.vue"),
    children: [
  {
    name: "system-organisations-id",
    path: ":id()",
    meta: { ...(_91id_93Wl89T2mSOXy_fTQw_45tW7dvWT2NzgXOXYZmJj0LsqKvoMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations/[id].vue"),
    children: [
  {
    name: "system-organisations-id-organisationUsers",
    path: "organisationUsers",
    meta: organisationUsersfj5O0VB9f5wthqqIn6EKPP0LVtK_45EwseFcdQgtOrt00Meta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations/[id]/organisationUsers.vue")
  },
  {
    name: "system-organisations-id-organisationPackage",
    path: "organisationPackage",
    meta: organisationPackage6mGQKoyzvKOU6imuIaFtXZ7NlEQ86VvZJvmhQGRp__45gMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations/[id]/organisationPackage.vue")
  },
  {
    name: "system-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    meta: organisationBaseDataCoo82o3_7_uC6wtWjNMIitTV6inibtBCZBTmmcfhI0AMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "system-organisations-id-organisationActivities",
    path: "organisationActivities",
    meta: organisationActivities2svEjMql5o4zxNV_tp4us82382tYT0pW1zJN1BuSt9oMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "system-organisations-id-organisationSystemData",
    path: "organisationSystemData",
    meta: organisationSystemDataN8LuokDLlTd8WObF6Ut0B_f_45BAB_qkdUHkQEiahjlEEMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations/[id]/organisationSystemData.vue")
  },
  {
    name: "system-organisations-id-organisationMailSettings",
    path: "organisationMailSettings",
    meta: organisationMailSettingsigOS_45kCKQe1BWa7YKekPLQ7YYc5rJig_JWdrQUYLaTsMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations/[id]/organisationMailSettings.vue")
  }
]
  },
  {
    name: "system-organisations",
    path: "",
    meta: { ...(indexJNQ9JLvF8Foalw3jMBBtQUBe9qVuarwHzm9Swpu7fCwMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/organisations/index.vue")
  }
]
  },
  {
    name: "system-poolQuestions",
    path: "poolQuestions",
    meta: poolQuestionsxYYVvqfRD5iv0xUqKzWCrFLmp8JAD3KH7KeunGqcufUMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/poolQuestions.vue")
  },
  {
    name: "system-mailTemplates",
    path: "mailTemplates",
    meta: { ...(indexthrQ8W_ml1lCIGg7vJz7uIITIrvDzCHUuCT5g_qHbFsMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/mailTemplates/index.vue")
  },
  {
    name: "system-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplates/:id()/mailTemplateBaseData",
    meta: { ...(mailTemplateBaseDataKX08HvUbWIhYhudKw6EZKP0V9k2_FF0NuL41tv92vNAMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/system/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsjHe0VBedB_45ur1Zoiw8_4514tl9vE2FX9OyscE_E_45l_450acMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings.vue"),
    children: [
  {
    name: "settings-internal",
    path: "internal",
    meta: internaltx5CLKRlnNWeNlx5cQg8hUfeYgsG3Fyb3Ck2HxBNlpYMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal.vue"),
    children: [
  {
    name: "settings-internal-users-id",
    path: "users/:id()",
    meta: { ...(_91id_93GKd2niNYibVyJHfejCW10MpUr9VlqATa6lJ8MQrO6n4Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/users/[id].vue"),
    children: [
  {
    name: "settings-internal-users-id-userBaseData",
    path: "userBaseData",
    meta: userBaseDataj4m3Qi634_45_o1ptpVycmKeSrJvoSalkzaVoclxbhd6cMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-internal-users-id-userActivities",
    path: "userActivities",
    meta: userActivitiesUw1vjjXtTfZH8wNBDbYB1dLZ1cdnAg_aCqUuq7TkT6gMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/users/[id]/userActivities.vue")
  }
]
  },
  {
    name: "settings-internal-organisation",
    path: "organisation",
    meta: { ...(organisation6PZybWQh1SQjMnVLOHZm_45XVGMqGE6SqpmEVmDVNKf_450Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/organisation.vue"),
    children: [
  {
    name: "settings-internal-organisation-organisationUsers",
    path: "organisationUsers",
    meta: organisationUsers8adjZkYOSMW0d_4510JsADXJ7iuOc1k7ympowOLy9kHtMMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/organisation/organisationUsers.vue")
  },
  {
    name: "settings-internal-organisation-organisationPackage",
    path: "organisationPackage",
    meta: organisationPackageUEdDNL6MkOeDE1ftvTFtDGOltxlxUZG8ZJIerLfKrtQMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/organisation/organisationPackage.vue")
  },
  {
    name: "settings-internal-organisation-organisationBaseData",
    path: "organisationBaseData",
    meta: organisationBaseData5JTZ_45WXqZQkmF1oFK1muXr_LyRpr3kJ_45RMwVvyjavgEMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/organisation/organisationBaseData.vue")
  },
  {
    name: "settings-internal-organisation-organisationMailSettings",
    path: "organisationMailSettings",
    meta: organisationMailSettingssdu_0tQASMTAaTVwNNAZ4p67y60P41MlYGZMgpGLsMIMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/organisation/organisationMailSettings.vue")
  }
]
  },
  {
    name: "settings-internal-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplates/:id()/mailTemplateBaseData",
    meta: { ...(mailTemplateBaseDataBfSE9csUvOQM5JWZopkaoboy71plt9vAG2m6f5r2RbEMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/internal/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "settings-crisisManagers-id",
    path: "crisisManagers/:id()",
    meta: { ...(_91id_93tPN9S68bEUk7hG1EMMiaM0tNoj6IToINweDmSD5TLEoMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/crisisManagers/[id].vue")
  },
  {
    name: "settings-loginProviders-id",
    path: "loginProviders/:id()",
    meta: { ...(_91id_93pak6G2SdrAKTx6YEPATG9U3P8BpdhI3ZJweZdi_45iHL8Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/loginProviders/[id].vue")
  },
  {
    name: "settings-crisisManagers",
    path: "crisisManagers",
    meta: { ...(index2ZRYSHl67T1BaNjLus3k_kVOKR6cjKvr3P8Fnz5yn_45EMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/crisisManagers/index.vue")
  },
  {
    name: "settings-loginProviders",
    path: "loginProviders",
    meta: { ...(indexS43JuOX9RdfBYpMhTo3PIEXTsibGIj2BSz4q3vqolXcMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: "questions",
    path: "/questions",
    meta: questions4PIEdTxFwu8U5MjDG4ckHGyRlaXk8CEm44euSU_g1k4Meta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/questions.vue"),
    children: [
  {
    name: sets6rkDb08IG0Kw_s5998MIZ5MuSGVk253_45YYFq0gMCEmEMeta?.name,
    path: "sets",
    meta: sets6rkDb08IG0Kw_s5998MIZ5MuSGVk253_45YYFq0gMCEmEMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/questions/sets.vue"),
    children: [
  {
    name: "questions-sets-id",
    path: ":id()",
    meta: { ...(_91id_93f1BAhgMeD_exeysFd30uTxp12yOe_45NE_456Ya1tv8RNcIMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/questions/sets/[id].vue"),
    children: [
  {
    name: "questions-sets-id-setBaseData",
    path: "setBaseData",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/questions/sets/[id]/setBaseData.vue")
  }
]
  },
  {
    name: "questions-sets",
    path: "",
    meta: { ...(index_a_45mlK6Wyc_45pfaigtfomnzU4aIKKcCxcsEnLf5fV9tEMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/questions/sets/index.vue")
  }
]
  }
]
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexKrBHzrNCXCYMTrEzgojm1R41Pab1qbQojF65JyPFhS4Meta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/auth/index.vue")
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/secret/index/inputs.vue")
  },
  {
    name: "secret-index-mosaic",
    path: "mosaic",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/secret/index/mosaic.vue")
  },
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-components",
    path: "components",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/secret/index/components.vue")
  }
]
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: registersB0hIKnZriwrf2Vklgg_s9K28HPJzzlAVDf5jSyTrS8Meta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/auth/register.vue")
  },
  {
    name: "external-event",
    path: "/external/event",
    meta: eventfB4fkgV6GkW8GZhm8RvTX5A64tY3dNa6vkQ_xxiplk0Meta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/external/event.vue"),
    children: [
  {
    name: "external-event-event",
    path: ":event()",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/external/event/[event].vue"),
    children: [
  {
    name: "external-event-event-leader-leader",
    path: "leader/:leader()",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/external/event/[event]/leader/[leader].vue")
  },
  {
    name: "external-event-event-emergency-emergency",
    path: "emergency/:emergency()",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/external/event/[event]/emergency/[emergency].vue")
  },
  {
    name: "external-event-event-temporary-temporary",
    path: "temporary/:temporary()",
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/external/event/[event]/temporary/[temporary].vue")
  }
]
  }
]
  },
  {
    name: "auth-amos-organisation",
    path: "/auth/amos/:organisation()",
    meta: indexG_45fqNo3POh2E2KKW99IMvj1Hv_X2KFOugs2x7USYvmcMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/auth/amos/[organisation]/index.vue")
  },
  {
    name: "auth-social-organisation",
    path: "/auth/social/:organisation()",
    meta: indexBxQV4s1k_45tkAmOlSYmt0ayqEYXOprpXbMsAAJx5fURwMeta || {},
    component: () => import("/home/forge/develop.freizeitpass-digital.de/releases/82181701/client/pages/auth/social/[organisation]/index.vue")
  }
]